import {useQuery} from '@github-ui/react-query'
import {FetchCAPI401Error} from '../utils/fetch-capi'
import {useConsecutiveCAPI401sContext} from '../contexts/ConsecutiveCAPI401sContext'
import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useEffect} from 'react'

type UseQueryArgs<T> = Parameters<typeof useQuery<T>>

export function useCAPIQuery<T>(...args: UseQueryArgs<T>) {
  const result = useQuery(...args)
  const {numberOf401s, increment401s, reset401s} = useConsecutiveCAPI401sContext()
  const {isError, isLoading, error} = result
  const refreshTokenOn401Enabled = useFeatureFlag('copilot_coding_agent_refresh_token_on_401')

  useEffect(() => {
    if (refreshTokenOn401Enabled) {
      return
    }
    if (isError && error instanceof FetchCAPI401Error) {
      increment401s()
    } else if (!isError && !isLoading) {
      reset401s()
    } else if (numberOf401s > 5) {
      const tokenProvider = new AgentSessionsTokenProvider()
      tokenProvider.removeLocalStorageAuthToken()
      reset401s()
    }
  }, [isError, isLoading, error, increment401s, reset401s, numberOf401s, refreshTokenOn401Enabled])
  return result
}
